<template>
  <div class="mb-6">
    <!-- #region 標題、儲存 -->
    <div class="fixed-bar pt-6 white" style="top: 64px; z-index: 10">
      <div class="d-flex align-center mb-6">
        <div class="text-h6 font-weight-black">
          {{ title }}
        </div>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="save.loading" @click="Save()">
          {{ save.text }}
        </v-btn>
      </div>
    </div>

    <!-- #endregion -->
    <!-- #region 個人資料 -->
    <div class="d-flex align-center mb-8" style="z-index: 1">
      <v-row>
        <v-col cols="12" class="mb-3">
          <v-avatar color="grey lighten-4" size="64">
            <v-img
              :src="
                uploadPhoto.url !== ''
                  ? uploadPhoto.url
                  : uploadPhoto.defaultUrl
              "
              cover
            ></v-img>
          </v-avatar>
          <input
            ref="fileInput"
            type="file"
            style="display: none"
            @change="UploadFile()"
            accept="image/*"
          />
          <v-btn large class="ml-6" @click="$refs.fileInput.click()">{{
            uploadPhoto.text
          }}</v-btn>
        </v-col>
        <v-col cols="12" sm="6" class="py-0 pb-2">
          <v-text-field
            v-model="block1.field1.value"
            :label="block1.field1.label"
            :rules="block1.field1.rules"
            :error-messages="block1.field1.errorMsg"
            validate-on-blur
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" class="py-0 pb-2">
          <v-text-field
            v-model="block1.field2.value"
            :label="block1.field2.label"
            :rules="block1.field2.rules"
            :error-messages="block1.field2.errorMsg"
            validate-on-blur
            disabled
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" class="py-0 pb-2">
          <v-menu
            v-model="block1.field3.menu"
            :close-on-content-click="false"
            transition="scale-transition"
            min-width="auto"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="input-width"
                v-model="block1.field3.value"
                :label="block1.field3.label"
                :placeholder="block1.field3.placeholder"
                :rules="block1.field3.rules"
                :error-messages="block1.field3.errorMsg"
                validate-on-blur
                outlined
                dense
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="block1.field3.date"
              :active-picker.sync="block1.field3.activePicker"
              min="1950-01-01"
              locale="zh-TW"
              @change="SaveBirthday"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" class="py-0 pb-2">
          <v-select
            v-model="block1.field4.value"
            :items="block1.field4.items"
            :label="block1.field4.label"
            :rules="block1.field4.rules"
            :error-messages="block1.field4.errorMsg"
            validate-on-blur
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col cols="6" sm="5" md="4" lg="3" class="py-0">
          <v-combobox
            v-model="block1.field5.value"
            :items="block1.field5.items"
            :label="block1.field5.label"
            :rules="block1.field5.rules"
            :error-messages="block1.field5.errorMsg"
            item-text="format"
            item-value="phoneCode"
            allow-overflow
            return-object
            validate-on-blur
            outlined
            dense
          ></v-combobox>
        </v-col>
        <v-col cols="6" sm="7" md="8" lg="9" class="py-0">
          <v-text-field
            v-model="block1.field6.value"
            :label="block1.field6.label"
            :rules="block1.field6.rules"
            :error-messages="block1.field6.errorMsg"
            validate-on-blur
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <!-- #endregion -->
    <v-divider></v-divider>
    <!-- #region 地址-->
    <div class="d-flex align-center my-8">
      <div class="d-none d-md-flex mr-3">
        <v-avatar color="grey lighten-4" size="44">
          <v-icon color="black"> mdi-map </v-icon>
        </v-avatar>
      </div>
      <div>
        <div class="font-weight-black text-h6">{{ block2.title }}</div>
        <div class="text-body-2">{{ block2.sub }}</div>
      </div>
    </div>
    <Address
      :style="
        $vuetify.breakpoint.width < 600
          ? {
              marginBottom: '320px',
            }
          : { marginBottom: '160px' }
      "
      :originalAddress="block2.value"
      v-on:address="GetAddress"
    />
    <!-- #endregion -->

    <!--  #region 提示條 -->
    <v-snackbar
      top
      v-model="snackbar.show"
      :timeout="snackbar.timeout ? snackbar.timeout : 3000"
      :color="snackbar.color ? 'red' : ''"
    >
      <v-avatar :color="snackbar.color ? '' : 'green'" size="17" class="mr-4">
        <div class="d-flex jsutify-center">
          <v-icon x-small>
            {{ snackbar.color ? "mdi-close" : "mdi-check" }}</v-icon
          >
        </div>
      </v-avatar>
      {{ snackbar.content }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">
          {{ snackbar.close }}
        </v-btn>
      </template>
    </v-snackbar>
    <!-- #endregion -->

    <!-- #region 裁剪照片dialog -->
    <ProfilePhotoCropper
      :open="uploadPhoto.cropperDialog"
      :imgFile="uploadPhoto.imageForCrooper"
      v-on:files="GetCroppedPhoto"
      v-on:close="CloseDialog"
    ></ProfilePhotoCropper>
    <!-- #endregion -->
  </div>
</template>

<script>
// 資料來源: https://www.ifreesite.com/phone/international-area-code.htm
import countryCode from "@/assets/countryCode.json";

import Address from "../../components/Common/Address";
import ProfilePhotoCropper from "../../components/Common/ProfilePhotoCropper";

import { Profile_Get, Profile_Post, Token_Username } from "@/apis/api.js";

export default {
  components: {
    Address,
    ProfilePhotoCropper,
  },
  data() {
    return {
      title: "個人資料",
      photo: "",
      save: {
        text: "儲存",
        loading: false,
      },
      formatedCountryCode: [],
      uploadPhoto: {
        text: "上傳照片",
        url: "",
        defaultUrl: require("@/assets/image/common/user-img.svg"),
        file: [],
        imageForCrooper: null,
        cropperDialog: false,
      },
      block1: {
        field1: {
          label: "姓名",
          placeholder: "",
          value: "",
          rules: [],
          errorMsg: "",
        },
        field2: {
          label: "電子信箱",
          placeholder: "",
          value: "",
          rules: [
            (v) => !!v || "此欄位必填",
            (v) =>
              /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(
                v
              ) || "請輸入正確的e-mail格式",
          ],
          errorMsg: "",
        },
        field3: {
          label: "生日",
          placeholder: "",
          value: "",
          rules: [],
          errorMsg: "",
          activePicker: null,
          menu: false,
          date: null,
        },
        field4: {
          label: "性別",
          items: ["男", "女"],
          placeholder: "",
          value: "",
          rules: [],
          errorMsg: "",
        },
        field5: {
          label: "行動電話",
          placeholder: "",
          items: [],
          value: "",
          rules: [],
          errorMsg: "",
        },
        field6: {
          label: "",
          placeholder: "",
          value: "",
          rules: [(v) => /^[0-9]*$/.test(v) || "請輸入數字"],
          errorMsg: "",
        },
      },
      block2: {
        title: "通訊地址",
        sub: "通訊地址僅作為使用小芋頭產品時將自動帶入資料，僅個人可見。",
        value: "",
      },
      snackbar: {
        show: false,
        close: "關閉",
        content: "",
        color: null,
        timeout: null,
      },
    };
  },
  mounted() {
    this.SetDefaultValue();
    this.Token_UsernameApi();
    this.Profile_GetApi(this.$store.state.username);
  },
  watch: {
    "block1.field3.menu"(val) {
      val && setTimeout(() => (this.block1.field3.activePicker = "YEAR"));
    },
  },
  methods: {
    //#region 設定預設值
    SetDefaultValue() {
      this.formatedCountryCode = this.FormatCountryCode(countryCode);
      this.block1.field5.items = this.formatedCountryCode;
      this.block1.field5.value = this.formatedCountryCode.filter(
        (x) => x.en === "Taiwan"
      )[0];

      this.block1.field2.value = "kingfong@gmail.com";
      //   this.uploadPhoto.url = "https://pics.ettoday.net/images/2471/2471912.jpg";
      //   this.block2.value = "台灣 高雄市 左營區 大順一路";
    },
    //#endregion
    //#region 儲存生日日期
    SaveBirthday(date) {
      this.block1.field3.value = date;
      this.block1.field3.menu = false;
    },
    //#endregion
    //#region 格式化下拉選單的呈現文字
    FormatCountryCode(data) {
      data.forEach((x) => {
        x["format"] = `${x.en} ${x.zhTW} (+${x.phoneCode})`;
      });
      return data;
    },
    //#endregion
    //#region 上傳照片
    UploadFile() {
      const file = this.$refs.fileInput.files[0];
      this.snackbar.show = false;
      this.snackbar.content = "";
      this.snackbar.color = null;
      this.snackbar.timeout = 5000;

      // 非圖片檔
      if (!file.type.includes("image/")) {
        this.snackbar.show = true;
        this.snackbar.content = "請上傳圖片類型的檔案。";
        this.snackbar.color = "red";
        this.snackbar.timeout = 5000;
        return false;
      }

      // 檔案過大
      if (file.size > 10 * 1024 * 1024) {
        this.snackbar.show = true;
        this.snackbar.content = "檔案限制" + 10 + "MB，請重新上傳";
        this.snackbar.color = "red";
        this.snackbar.timeout = 6000;
        return false;
      }
      if (!file && file.length < 1) {
        return false;
      }
      this.uploadPhoto.cropperDialog = true;
      this.uploadPhoto.imageForCrooper = file;
    },
    //#endregion
    //#region 拿裁切後的圖片
    GetCroppedPhoto(data) {
      this.uploadPhoto.cropperDialog = false;
      this.uploadPhoto.file = data; // 塞檔案
      this.PreviewImage(data); //預覽
    },
    //#endregion
    //#region 預覽圖片
    PreviewImage(file) {
      this.uploadPhoto.url = URL.createObjectURL(file);
    },
    //#endregion
    //#region 拿地址
    GetAddress(data) {
      this.block2.value = data;
    },
    //#endregion
    //#region 儲存
    Save() {
      this.save.loading = true;

      this.PhoneFormat();

      let form = new FormData();
      form.append("name", this.block1.field1.value);
      form.append("email", this.block1.field2.value);
      form.append("birthday", this.block1.field3.value);
      form.append("gender", this.block1.field4.value);
      form.append(
        "phone",
        `(+${this.block1.field5.value.phoneCode})${this.block1.field6.value}`
      );
      form.append("address", this.block2.value);
      form.append("photo", this.uploadPhoto.file);

      this.Profile_PostApi(form);
    },
    //#endregion
    //#region 輸入電話去開頭0
    PhoneFormat() {
      let splited = this.block1.field6.value.split("");
      if (splited[0] === "0" && this.block1.field6.value.length > 1) {
        splited.shift();
      }
      let joined = splited.join("");
      this.block1.field6.value = joined;
    },
    //#endregion
    //#region 關閉彈窗
    CloseDialog() {
      this.uploadPhoto.cropperDialog = false;
    },
    //#endregion
    // #region APIs

    Profile_PostApi(data) {
      Profile_Post(data)
        .then((res) => {
          this.snackbar.content = res.data.message;
          this.snackbar.color = "";
        })
        .catch((err) => {
          console.log(err.response.data);
          this.snackbar.content = err.response.data.message;
          this.snackbar.color = "red";
        })
        .finally(() => {
          this.save.loading = false;
          this.snackbar.show = true;
          this.snackbar.timeout = 3000;

          this.Profile_GetApi(this.$store.state.username);
        });
    },
    Profile_GetApi(email) {
      Profile_Get(email)
        .then((res) => {
          let data = res.data.data;
          this.block1.field1.value = data.name === null ? "" : data.name;
          this.block1.field2.value = data.email === null ? "" : data.email;
          this.block1.field3.value =
            data.birthday === null ? "" : data.birthday;
          this.block1.field4.value = data.gender === null ? "" : data.gender;

          //#region format 電話
          let index = res.data.data.phone.indexOf(")");
          let phoneCode = null;

          if (index > -1) {
            phoneCode = res.data.data.phone.slice(2, index);
          }

          let phoneNumber = res.data.data.phone.slice(
            index + 1,
            res.data.data.phone.length
          );

          phoneCode = this.formatedCountryCode.filter(
            (x) => String(x.phoneCode) === String(phoneCode)
          )[0];
          //#endregion

          this.block1.field5.value = phoneCode;
          this.block1.field6.value = phoneNumber === null ? "" : phoneNumber;
          this.block2.value = data.address === null ? "" : data.address;
          this.uploadPhoto.url = res.data.data.photoUrl;
          this.$store.state.userPhoto = res.data.data.photoUrl;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          //TODO:
        });
    },
    Token_UsernameApi() {
      Token_Username()
        .then((res) => {
          this.block1.field2.value = res.data;
        })
        .catch((err) => {
          console.log(err.response);
          this.block1.field2.value = "";
        });
    },
    //#endregion
  },
};
</script>

<style scoped></style>
